// extracted by mini-css-extract-plugin
export default {"container":"Card_container__w-y9D","icon":"Card_icon__1YUlt","title":"Card_title__oPqN+","description":"Card_description__UlyZr"};